import { render, staticRenderFns } from "./SelectBatchModal.vue?vue&type=template&id=108e88fa&scoped=true&"
import script from "./SelectBatchModal.vue?vue&type=script&lang=js&"
export * from "./SelectBatchModal.vue?vue&type=script&lang=js&"
import style0 from "./SelectBatchModal.vue?vue&type=style&index=0&id=108e88fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108e88fa",
  null
  
)

export default component.exports